import React, { useEffect, useRef } from 'react'
import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {MasterInit} from './MasterInit'
import {PageDataProvider} from './core'
import { Toast } from '../../app/modules/common/helper'
import useNetworkWatcher from '../../app/selectors/netWorkWatcher'
import { usePermissionChecker } from '../../app/hooks/PermissionChecker'
import { LIST_PERMISSIONS } from '../../app/constants/common'
import { CheckStoreConfig } from './components/CheckStoreConfig'

const MasterLayout: React.FC = ({children}) => {
  const isOnline = useNetworkWatcher();
  const isFirstRender = useRef(true); 
  const {hasPermission} = usePermissionChecker();
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    Toast.fire({
      icon: isOnline ? 'success' : 'warning',
      title: isOnline ? 'Kết nối đã được khôi phục' : 'Kết nối không ổn định'
    })
  }, [isOnline]);

  return (
    <PageDataProvider>
      <div className='page d-flex flex-row flex-column-fluid'>
        <AsideDefault />
        <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
          <HeaderWrapper />

          <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
            <div className='post d-flex flex-column-fluid' id='kt_post'>
              <Content>{children}</Content>
            </div>
          </div>
          <Footer />
        </div>
      </div>
      {hasPermission(LIST_PERMISSIONS.STORES) && (
        <CheckStoreConfig/>
      )}
      <MasterInit />
      <ScrollTop />
      <div className="loading-bg">
        <span className="loader"></span>
      </div>
    </PageDataProvider>
  )
}

export {MasterLayout}
